import { createReducer } from "@reduxjs/toolkit";

import {
  getAllPostsBySubscription,
  getAllPostsBySubscriptionSuccess,
  getAllPostsBySubscriptionFailure,
  setPostsBySubscription,
  getAllPostsBySubscriptionReset,
  getPostsBySubscription,
  getPostsBySubscriptionSuccess,
  getPostsBySubscriptionFailure,
  getPostsBySubscriptionReset,
  getMorePostsBySubscription,
  getMorePostsBySubscriptionSuccess,
  getMorePostsBySubscriptionFailure,
  getSibilingPosts,
  getSibilingPostsSuccess,
  getSibilingPostsFailure,
} from "./actions";

const initialState = {
  isAllLoading: true,
  isLoading: true,
  postById: {},
  postBySubscription: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getAllPostsBySubscription.type, (state) => {
      state.isAllLoading = true;
    })
    .addCase(getAllPostsBySubscriptionSuccess.type, (state, { payload }) => {
      const { postById } = payload;

      state.isAllLoading = false;
      state.postById = { ...state.postById, ...postById };
    })
    .addCase(getAllPostsBySubscriptionFailure.type, (state) => {
      state.isAllLoading = false;
    })
    .addCase(getAllPostsBySubscriptionReset.type, (state) => {
      state.isAllLoading = true;
    })
    .addCase(getPostsBySubscription.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getPostsBySubscriptionSuccess.type, (state, { payload }) => {
      const { id, allPosts, postById } = payload;

      state.isLoading = false;
      state.postById = { ...state.postById, ...postById };
      state.postBySubscription[id] = allPosts;
    })
    .addCase(getPostsBySubscriptionFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(getPostsBySubscriptionReset.type, (state) => {
      state.isAllLoading = true;
    })
    .addCase(getMorePostsBySubscription.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getMorePostsBySubscriptionSuccess.type, (state, { payload }) => {
      const { postById, id, allPosts } = payload;

      state.isLoading = false;
      state.postById = { ...state.postById, ...postById };
      state.postBySubscription[id] = [
        ...state?.postBySubscription?.[id],
        ...allPosts,
      ];
    })
    .addCase(getMorePostsBySubscriptionFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(getSibilingPosts.type, (state) => {
      state.isGettingSibilings = true;
    })
    .addCase(getSibilingPostsSuccess.type, (state, { payload }) => {
      const { nextPost, nextPostId, prevPost, prevPostId } = payload;

      if (nextPost) state.postById[nextPostId] = nextPost;
      if (prevPostId) state.postById[prevPostId] = prevPost;
      state.isGettingSibilings = false;
    })
    .addCase(getSibilingPostsFailure.type, (state) => {
      state.isGettingSibilings = false;
    })
    .addCase(setPostsBySubscription.type, (state, { payload }) => {
      const { id, allPosts } = payload;

      state.postBySubscription[id] = allPosts;
    });
});
